import Http from '@/support/http';
import S from '@/support/string';

import {
	compact
} from 'lodash';

const MEDICINE_BASE_PATH = 'v1/student-medicine/';

export default {
	getMedicine(context, payload) {

		if (payload) {

			const queryString = S.makeQueryString(payload);

			return Http.get(`${ MEDICINE_BASE_PATH }user/${ payload.user }${ queryString }`).then((response) => {

				context.commit('SET_MEDICINE', response.data);
				context.commit('FILTER_STUDENT_MEDICINE', payload.filter.student);
				context.commit('FILTER_DATE_MEDICINE', payload.filter.date);

				return response;

			});

		}
	},
	getMedicineIsTaken(context, payload) {

		if (payload) {

			return compact(context.state.list.map((item) => {

				if (item.medicinesTaken || item.rejectionReason) {
					return item;
				}

			}));

		} else {

			return compact(context.state.list.map((item) => {

				if (!item.medicinesTaken && !item.rejectionReason) {

					item.takenHour = '';
					item.reject = false;

					return item;

				}

			}));

		}

	},
	setMedicineHistory(context, payload) {
		context.commit('SET_MEDICINE_HISTORY', payload);
	},
	setMedicinePending(context, payload) {
		context.commit('SET_MEDICINE_PENDING', payload);
	},
	saveMedicineTaken(context, payload) {

		const route = `${ MEDICINE_BASE_PATH }${ payload.id }/user/${ payload.userId }`;

		return Http.post(route, {
			time: payload.time
		}).then((response) => {
			return response;
		});

	},
	setRejectMedicine(context, payload) {
		context.commit('SET_REJECT_MEDICINE', payload);
	},
	setRejectionReasonMedicine(context, payload) {

		const route = `${ MEDICINE_BASE_PATH }${ payload.id }/user/${ payload.userId }/reject`;

		return Http.put(route, {
			rejectionReason: payload.rejectionReason
		}).then((response) => {
			return response;
		});

	},
	cancelRejectionReasonMedicine(context, payload) {

		const route = `${ MEDICINE_BASE_PATH }${ payload.id }/user/${ payload.userId }/reject/revert`;

		return Http.put(route).then((response) => {
			return response;
		});

	}
};



// WEBPACK FOOTER //
// ./sources/app/medicine/actions.js